import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { VasState, Payload, Item } from '@/store/Vas/state';
// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

import { VasConfig } from '@/data/vasConfig';

const vasConfig = new VasConfig();

const count = (state: VasState) => (payload: Payload) => {
  const targetList = find(state)(payload);
  const result = targetList.reduce((z, item, index, array) => {
    return (z += item.count);
  }, 0);
  return result;
};

const find = (state: VasState) => (payload: Payload): Item[] => {
  return state.vas.filter(item => {
    return item && (payload.id ? item.id === payload.id : true);
  });
};

// 初期費用
const initialTotalAmount = (state: VasState): number => {
  let total = 0;

  // VASオプション代金(1社ごとにかかる代金)
  total += _.reduce(
    vasConfig.vasCategoryId(),
    (z: number, categoryId: string) => {
      const ids = vasConfig.findVasIdsBy(categoryId);
      const categoryTotal = state.vas.reduce((y: number, data) => {
        if (ids.includes(data.id)) {
          y += data.count;
        }
        return y;
      }, 0);

      if (categoryTotal > 0) {
        z += vasConfig.getVas(ids[0]).categoryInitCharge;
      }
      return z;
    },
    0
  );
  return total;
};

// 月額費用
const totalAmountOfMonth = (state: VasState) => {
  let total = 0;

  total += state.vas.reduce((z: number, data) => {
    const charge = vasConfig.getVas(data.id).monthlyCharge;
    z += charge * data.count;
    return z;
  }, 0);
  return total;
};

const getters: GetterTree<VasState, RootState> = {
  count,
  find,
  initialTotalAmount,
  totalAmountOfMonth,
};

export default getters;
